// src/components/exam/charts/SectionRadarChart.jsx

import React from 'react';
import { RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, ResponsiveContainer, Tooltip } from 'recharts';
import { AlertCircle } from 'lucide-react';

const SectionRadarChart = ({ data }) => {
  // Custom tooltip - Show RAW SCORES
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      return (
        <div className="bg-white p-3 border border-gray-200 rounded-lg shadow-lg">
          <p className="text-sm font-semibold text-gray-800">{payload[0].payload.subject}</p>
          <p className="text-sm text-blue-600">Current: {payload[0].value}</p>
          <p className="text-sm text-purple-600">Average: {payload[1].value}</p>
        </div>
      );
    }
    return null;
  };

  // Debug logging
  console.log('🔍 SectionRadarChart received data:', data);

  // ✅ Check if data is valid
  if (!data || data.length === 0) {
    console.warn('⚠️ No radar data available');
    return (
      <div className="w-full bg-white rounded-lg p-6 border border-gray-200">
        <div className="flex items-center gap-3 text-gray-600">
          <AlertCircle className="w-5 h-5" />
          <div>
            <p className="font-semibold">No Section Data Available</p>
            <p className="text-sm">Complete exams to compare sections</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full bg-white rounded-lg p-6 border border-gray-200">
      <h3 className="text-lg font-semibold text-gray-900 mb-2">🎯 Section Comparison</h3>
      <p className="text-sm text-gray-600 mb-4">Current exam vs. your average performance</p>

      <ResponsiveContainer width="100%" height={350}>
        <RadarChart data={data}>
          <PolarGrid stroke="#e5e7eb" />
          <PolarAngleAxis dataKey="subject" />
          <PolarRadiusAxis angle={90} domain={[0, 100]} />
          <Radar
            name="Average"
            dataKey="average"
            stroke="#a855f7"
            fill="#a855f7"
            fillOpacity={0.25}
            dot={{ fill: '#a855f7', r: 4 }}
          />
          <Radar
            name="Current Exam"
            dataKey="current"
            stroke="#3b82f6"
            fill="#3b82f6"
            fillOpacity={0.25}
            dot={{ fill: '#3b82f6', r: 4 }}
          />
          <Tooltip content={<CustomTooltip />} />
          <Legend />
        </RadarChart>
      </ResponsiveContainer>

      {/* Info Box */}
      <div className="mt-4 p-4 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-gray-700">
          <span className="text-blue-600 font-semibold">Blue area</span> shows your current exam performance.
          <br />
          <span className="text-purple-600 font-semibold">Purple area</span> shows your historical average.
        </p>
      </div>
    </div>
  );
};

export default SectionRadarChart;
